import { render, staticRenderFns } from "./InputPhoneNew.vue?vue&type=template&id=68dfd5d8&"
import script from "./InputPhoneNew.vue?vue&type=script&lang=js&"
export * from "./InputPhoneNew.vue?vue&type=script&lang=js&"
import style0 from "./InputPhoneNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports